import { Link } from "react-router-dom";
import { ArrowRight, Clock, MapPin, Bike } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SHOP, IMG } from "@/data/site";

export default function Tentang() {
    return (
        <div className="pt-24 lg:pt-32" data-testid="tentang-page">
            <header className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <Reveal>
                    <span className="eyebrow">Kenal lebih dekat</span>
                </Reveal>
                <Reveal delay={0.08}>
                    <h1 className="mt-4 font-display text-5xl font-extrabold tracking-tighter text-ink sm:text-6xl lg:text-7xl">
                        Tentang <span className="text-accent">Kami.</span>
                    </h1>
                </Reveal>
            </header>

            <section className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8 lg:py-20">
                <div className="grid items-center gap-12 lg:grid-cols-2">
                    <Reveal>
                        <div className="overflow-hidden rounded-[2rem] border border-ink/5 shadow-soft">
                            <img
                                src={IMG.shopInterior}
                                alt="Interior cafe Yuhuku Kopi"
                                className="aspect-[4/3] w-full object-cover"
                            />
                        </div>
                    </Reveal>
                    <div>
                        <Reveal>
                            <h2 className="font-display text-3xl font-extrabold tracking-tight text-ink sm:text-4xl">
                                Cafe kecil, rasa besar.
                            </h2>
                        </Reveal>
                        <Reveal delay={0.1}>
                            <p className="mt-6 leading-relaxed text-ink-muted">
                                Yuhuku Kopi adalah cafe kecil di Perum
                                Raffles Residence, Bandar Lampung. Namanya unik
                                dan jarang dilupakan — begitu juga kopinya. Kami
                                percaya kopi enak nggak harus mahal: bahan yang
                                jujur, dibuat fresh di depan kamu, dengan harga
                                yang ramah di kantong.
                            </p>
                            <p className="mt-4 leading-relaxed text-ink-muted">
                                Dari espresso klasik sampai matcha yang creamy,
                                dari gelas 250ml sampai botol seliter buat
                                dibagi — semuanya ada tempatnya di Yuhuku.
                                Mampir santai, bungkus jalan, atau pesan lewat
                                GoFood.
                            </p>
                        </Reveal>
                        <Reveal delay={0.18}>
                            <ul className="mt-8 flex flex-col gap-3">
                                <li className="flex items-center gap-3 text-sm font-medium text-ink">
                                    <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-soft text-accent">
                                        <Clock className="h-4 w-4" />
                                    </span>
                                    Buka setiap hari, 11.00–21.00 WIB
                                </li>
                                <li className="flex items-center gap-3 text-sm font-medium text-ink">
                                    <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-soft text-accent">
                                        <MapPin className="h-4 w-4" />
                                    </span>
                                    {SHOP.address}
                                </li>
                                <li className="flex items-center gap-3 text-sm font-medium text-ink">
                                    <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-soft text-accent">
                                        <Bike className="h-4 w-4" />
                                    </span>
                                    Tersedia di GoFood untuk pengantaran
                                </li>
                            </ul>
                        </Reveal>
                    </div>
                </div>
            </section>

            <section className="px-4 sm:px-6 lg:px-8">
                <div className="mx-auto grid max-w-7xl items-center gap-12 rounded-[2.5rem] border border-ink/5 bg-white p-6 shadow-soft sm:p-10 lg:grid-cols-2 lg:p-14">
                    <Reveal>
                        <h2 className="font-display text-3xl font-extrabold tracking-tight text-ink sm:text-4xl">
                            Kenapa namanya <span className="text-accent">Yuhuku?</span>
                        </h2>
                        <p className="mt-6 leading-relaxed text-ink-muted">
                            Namanya memang beda dari cafe pada umumnya —
                            dan itu disengaja. Yuhuku mudah diingat, mudah
                            disebut, dan sedikit jadi candaan sendiri tiap kali
                            orang pertama kali membacanya. Begitu juga
                            pengalamannya: sederhana, jujur, dan bikin balik
                            lagi.
                        </p>
                        <p className="mt-4 leading-relaxed text-ink-muted">
                            Website ini adalah bagian dari pengembangan presence
                            digital Yuhuku Kopi — supaya cafe kecil di Raffles
                            Residence ini bisa ditemukan lebih banyak orang.
                        </p>
                    </Reveal>
                    <Reveal delay={0.12}>
                        <div className="overflow-hidden rounded-[2rem] border border-ink/5">
                            <img
                                src={IMG.shopExterior}
                                alt="Etalase depan Yuhuku Kopi"
                                className="aspect-[4/3] w-full object-cover"
                            />
                        </div>
                    </Reveal>
                </div>
            </section>

            <section className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8 lg:py-20">
                <Reveal>
                    <div className="flex flex-wrap items-center justify-between gap-4 rounded-3xl border border-ink/5 bg-white px-6 py-5 shadow-soft sm:px-8">
                        <p className="font-semibold text-ink">
                            Penasaran? Mulai dari menu andalannya dulu.
                        </p>
                        <Link to="/menu" data-testid="tentang-cta-menu" className="btn-primary">
                            Lihat Menu <ArrowRight className="h-4 w-4" />
                        </Link>
                    </div>
                </Reveal>
            </section>
        </div>
    );
}